export const ACTIVATE = "ACTIVATE_USER_PROMO";

export const UPDATE = "UPDATE_USER_PROMO";

export const READ = "READ_USER_PROMO";

export const DISABLE = "DISABLE_USER_PROMO";